import { HEADER_DIRECTION } from "constants/message";
import { jsPDF } from "jspdf";
import { DIRECTION_OPTIONS, TRAFFIC_VOLUME_TYPE } from "utils/constanst";

const loadImageAsBase64 = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(file);
  });
};

const loadImageDimensions = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ img, width: img.width, height: img.height });
    img.onerror = reject;
    img.src = src;
  });
};

const createPdfFromImage = async (imageData, width, height) => {
  const pdf = new jsPDF({
    orientation: width > height ? "landscape" : "portrait",
    unit: "px",
    format: [width, height],
    hotfixes: ["px_scaling"],
  });
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();
  pdf.addImage(imageData, "JPEG", 0, 0, pdfWidth, pdfHeight);
  return pdf;
};

const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const formatDirection = (direction) => {
  if (!direction) return "";

  const directionOption = DIRECTION_OPTIONS.find(
    (option) => option.value === direction,
  );

  if (!directionOption) return "";

  if (["INBOUND", "OUTBOUND"].includes(directionOption.value)) {
    return directionOption.label;
  }

  return `${directionOption.label}${HEADER_DIRECTION}`;
};

const retrieveDirectionValue = (sensor) => {
  const countableCamera = sensor?.data?.trafficVolumeCountableCamera;

  if (countableCamera == 1) {
    return formatDirection(sensor?.data?.camera1Direction);
  }

  if (countableCamera == 2) {
    return formatDirection(sensor?.data?.camera2Direction);
  }

  return "";
};

const getLabelByScenario = (scenario, sensor) => {
  switch (scenario) {
    case -1:
      return '自動車合計';
    case 0:
      return '歩行者合計';
    default:
      return `[${sensor.data[`trafficVolumeType${scenario}`] === TRAFFIC_VOLUME_TYPE.VEHICLE ? "自動車" : "歩行者"}]${sensor.data[`trafficVolumeName${scenario}`].trim()}`
  }
}

export {
  loadImageAsBase64,
  loadImageDimensions,
  createPdfFromImage,
  downloadBlob,
  retrieveDirectionValue,
  getLabelByScenario,
};
